import React from "react";
import { Link } from "react-router-dom";
import { imageUrl } from "@/lib/api";
import { Star } from "lucide-react";

export default function VenueCard({ venue }) {
  return (
    <Link
      to={`/venues/${venue.slug}`}
      data-testid={`venue-card-${venue.slug}`}
      className="group relative flex flex-col overflow-hidden rounded-xl bg-[#141417] border border-[#27272A] transition-all duration-300 hover:border-[#D4AF37]/60"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={imageUrl(venue.hero_image)}
          alt={venue.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 card-fade" />
        <div className="absolute top-3 left-3">
          {venue.abe_owned ? (
            <span className="inline-flex items-center gap-1 rounded bg-[#D4AF37] px-2 py-1 font-oswald text-[10px] font-bold tracking-widest text-black">
              <Star size={11} /> ABE VENUE
            </span>
          ) : (
            <span className="rounded bg-black/70 px-2 py-1 font-oswald text-[10px] font-bold tracking-widest text-white backdrop-blur">
              PARTNER VENUE
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="font-display text-xl uppercase leading-none text-white">{venue.name}</h3>
          <p className="mt-1 text-xs text-zinc-400">{venue.city}</p>
        </div>
      </div>
      <div className="p-4">
        <div className="w-full text-center rounded-md border border-white/15 py-2.5 font-oswald text-sm font-semibold tracking-wide text-white transition-colors group-hover:border-[#D4AF37] group-hover:text-[#D4AF37]">
          VIEW EVENTS
        </div>
      </div>
    </Link>
  );
}
